<template lang='pug'>
  div
    v-tooltip(right)
      template(v-slot:activator='{on}')
        v-btn(v-on='on' @click='showDialog = !showDialog' text icon color='primary')
          v-icon add
      span Add Module
    v-dialog(v-model='showDialog' max-width='500px')
      form(@submit.prevent='createModule' v-if='showDialog')
        v-card
          v-card-title
            span.text-h5.primary--text.text--lighten-2 Create Module
          v-card-text
            v-container(grid-list-md)
              v-text-field(label='Code Name' v-model='codeName' required autofocus)
              v-text-field(v-if='gitMode' label='Filename' placeholder='module.js' v-model='gitName' required)
              v-textarea(outlined auto-grow label='Description' v-model='description')
          v-card-actions
            v-spacer
            v-btn(text @click.native='showDialog=false') Cancel
            v-btn(text color='primary' type='submit') Create
</template>

<script>
import {get} from 'lodash';
import {mapGetters} from 'vuex';
import Notifications from '../services/notification.service';
import FilenameMixin from '../mixins/filename.mixin';
import AMacro from '../api/amacro';

export default {
  name: 'BionicMetricsCreateModule',
  mixins: [FilenameMixin],
  computed: {
    gitMode() {
      return get(this.account, 'gitMode');
    },
    gitName: {
      get() {
        if (this.touched) return this.filename;
        return this.getSafeFilename(this.codeName);
      },
      set(value) {
        this.touched = true;
        this.filename = value;
      }
    },
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount'
    })
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    async createModule() {
      const codeName = this.codeName.replace(/[|!&;$%@"<>()+,\s]/g, '');
      try {
        const module = await AMacro.create({
          codeName,
          gitName: this.gitName,
          description: this.description
        });
        this.codeName = null;
        this.gitName = null;
        this.description = null;
        this.showDialog = false;
        this.$router.push(`/module/${module.guid}`);
      } catch (error) {
        console.error(`Error creating amacro: ${error.message}`);
        const message = get(error, 'response.data.message');
        if (message === 'CODENAME_TAKEN') return Notifications.alert(`<strong>${codeName}</strong> is either already in use in another module or is a reserved keyword. Please choose a different value.`);
        if (message === 'DUPLICATE') return Notifications.alert(`<strong>${this.gitName}</strong> is already used in another module. Please choose a different filename.`);
        Notifications.alert('There was a problem creating the module');
      }
    }
  },
  data() {
    return {
      touched: false,
      showDialog: false,
      codeName: null,
      filename: null,
      description: null
    };
  }
};
</script>

<style scoped>

</style>
